import React from 'react';
import ProjectList from './ProjectList';
import '../tools/journal/SiteJournal.css';

export default function ProjectsAdmin({ onBack, onOpenJournalProject }) {
    return (
        <div className="projects-admin-container">
            {/* Creates a wrapper to match the previous layout structure */}
            <div className="header-container">
                <div className="header-top-row">
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <h2 className="page-main-title">Bautagebuch - Projekte</h2>
                        {/* New Project Button is now inside ProjectList */}
                    </div>
                    {/* Keep the Back Button here for consistency with other Admin views */}
                    <button onClick={onBack} className="btn-header-back">← Zurück zur Tool-Übersicht</button>
                </div>
            </div>

            <ProjectList variant="admin" onProjectSelect={onOpenJournalProject} />
        </div>
    );
}